import { Injectable, Renderer } from '@angular/core';

import { ApiService, LogService, AppContext } from './../../shared';

@Injectable()
export class EmailDeliveryService {
  emailSchedules = new Array<any>();
  public loaderOn = false;

  constructor(private api: ApiService, private logger: LogService, public app: AppContext, private renderer: Renderer) {
    this.getEmailSchedules();
  }

  update(oldSchedule, newSchedule) {
    try {
      for (let current = 0; current < this.emailSchedules.length; current++) {
        if (this.emailSchedules[current].id === oldSchedule.id) {
          this.emailSchedules[current] = newSchedule;
        }
      }
    } catch (ex) {
      this.logger.log('email-delivery.service', 'update catch', ex);
    }
  }

  add() {
    if (this.emailSchedules.length < this.app.maxSchedules) {
      this.emailSchedules.push({
        id: this.emailSchedules.length,
        type: 'portPair',
        originPort: {
          id: 0,
          name: ''
        },
        destinationPort: {
          id: 0,
          name: ''
        }
      });
    }
  }

  getEmailSchedules() {
    this.loaderOn = true;
    this.api.getApiClient().then(client => this.callGetEmailSchedules(client));
  }

  callGetEmailSchedules(apigClient: any) {
    this.logger.log('email-delivery.service', 'callGetEmailSchedules', 'hello');
    let params = {};
    let body = {};
    let additionalParams = { headers: { 'Content-Type': 'application/json' } };
    try {
      apigClient.userEmailDeliverySchedulesGet(params, body, additionalParams)
        .then((result) => {
          this.logger.log('email-delivery.service', 'result', result);
          this.loaderOn = false;
          if (result !== null && result.data !== null) {
            this.emailSchedules = result.data;
          }
        }).catch((err) => {
          this.api.handleError(err);
          this.loaderOn = false;
          this.app.showMessage('Network Error', 'Please refresh the page to try again. If this issue persists, please contact our support');
        });
    } catch (ex) {
      this.loaderOn = false;
      this.app.showMessage('Network Error', 'Please refresh the page to try again. If this issue persists, please contact our support');
    }
  }

  delete(el, scheduleId: string) {
    this.renderer.setElementClass(el, 'loading', true);
    this.api.getApiClient().then(client => this.callDelete(client, scheduleId))
      .then((result) => {
        this.logger.log('email-delivery.service', 'delete successful', result);
        this.renderer.setElementClass(el, 'loading', false);
        for (let current = 0; current < this.emailSchedules.length; current++) {
          if (this.emailSchedules[current].id === scheduleId) {
            this.emailSchedules.splice(current, 1);
          }
        }
      })
      .catch((err) => {
        this.renderer.setElementClass(el, 'loading', false);
      });
  }

  callDelete(apigClient: any, scheduleId: string): Promise<any> {
    this.logger.log('email-schedule.service', 'callDelete', scheduleId);
    return new Promise((resolve, reject) => {
      let params = {
        scheduleId: scheduleId
      };
      let body = {
        scheduleId: scheduleId
      };
      let additionalParams = { headers: { 'Content-Type': 'application/json' } };
      try {
        apigClient.userEmailDeliverySchedulesScheduleIdDelete(params, body, additionalParams)
          .then((result) => {
            this.logger.log('email-schedule.service', 'delete result', result);
            resolve(result);
          }).catch((err) => {
            this.api.handleError(err);
            reject(err);
          });
      } catch (ex) {
        reject(ex);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/account/email-delivery/email-delivery.service.ts